import React from "react";
import { Field } from "formik";
function FieldSwitch({ name, className, children, disabled }) {
  return (
    <div className="field">
      <Field name={name}>{({ field, form, meta }) => <input type="checkbox" id={name} className={className} disabled={disabled} checked={field.value} {...field} />}</Field>
      <label htmlFor={name} className="label">
        {children}
      </label>
    </div>
  );
}
export default FieldSwitch;
